(() => {
  'use strict';
  if (window.dtPackPilotLoaded) return;
  window.dtPackPilotLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency', currency}).format(cents / 100);
  const el = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const request = async (path, options = {}) => {
    const response = await fetch(root + path, {cache:'no-store', ...options, headers:{Accept:'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify: ' + response.status);
    return data;
  };
  const post = (path, data) => request(path, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data)});
  const groupItems = (cart, group) => cart.items.filter(item => item.properties?._dt_pack_pilot === group || item.properties?.__dt_pack_pilot_native === group);
  const removeGroup = async group => {
    const cart = await request('cart.js');
    const updates = Object.fromEntries(groupItems(cart, group).map(item => [item.key, 0]));
    if (Object.keys(updates).length) await post('cart/update.js', {updates});
    const checked = await request('cart.js');
    if (groupItems(checked, group).length) throw new Error('Incomplete removal');
  };
  async function refreshDrawer(open = true) {
    if (typeof window.refreshCart === 'function') {
      try { await window.refreshCart(open); return; } catch (error) { console.warn('Pack pilot drawer refresh', error); }
    }
    const response = await fetch(root + '?section_id=helper-cart', {cache:'no-store'});
    if (!response.ok) throw new Error('Cart rendering failed');
    const html = await response.text();
    if (typeof window.renderHelperCart !== 'function') throw new Error('Cart renderer unavailable');
    window.renderHelperCart(html);
    if (open) document.querySelector('[data-js-site-cart-sidebar]')?.show?.();
  }
  async function changeGroupQuantity(group, quantity) {
    if (quantity === 0) return removeGroup(group);
    const cart = await request('cart.js');
    const lines = groupItems(cart, group);
    if (!lines.length || lines.some(line => line.quantity !== lines[0].quantity)) throw new Error('Inconsistent group');
    const previous = lines[0].quantity;
    if (quantity === previous) return;
    const restore = async () => {
      const latest = await request('cart.js');
      const updates = Object.fromEntries(groupItems(latest,group).map(line => {
        const old = lines.find(item => item.variant_id === line.variant_id);
        return [line.key, old?.quantity || 0];
      }));
      await post('cart/update.js',{updates});
    };
    try {
      if (quantity > previous) {
        await post('cart/add.js',{items:lines.map(line => ({id:line.variant_id,quantity:quantity-previous,properties:line.properties}))});
      } else {
        await post('cart/update.js',{updates:Object.fromEntries(lines.map(line => [line.key,quantity]))});
      }
      const checked = groupItems(await request('cart.js'),group);
      if (checked.length !== lines.length || checked.some(line=>line.quantity !== quantity)) throw new Error('Incomplete update');
    } catch (error) {
      await restore();
      throw error;
    }
  }
  function renderGroups() {
    const form = document.getElementById('AjaxCartForm');
    if (!form) return;
    const rows = [...form.querySelectorAll('[data-dt-pack-group]')].filter(row => row.dataset.dtPackGroup && !row.closest('.dt-pilot-group'));
    const groups = new Map();
    for (const row of rows) {
      const id = row.dataset.dtPackGroup;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(row);
    }
    for (const [id, items] of groups) {
      const first = items[0];
      const quantity = Number(first.dataset.qty) || 1;
      const wrapper = el('div', undefined, 'cart-item dt-pilot-group');
      wrapper.dataset.dtPilotCard = id;
      const thumbnail = el('a', undefined, 'cart-item__thumbnail element--border-width-clamped element--border-radius dt-pilot-pack-image');
      thumbnail.href = root + 'collections/packs-regalo?view=dt-pack-pilot';
      thumbnail.setAttribute('aria-label',first.dataset.dtPackTitle);
      for (const row of items.slice(0,4)) {
        const source = row.querySelector('.cart-item__thumbnail img');
        if (!source) continue;
        const image = el('img');
        image.src = source.currentSrc || source.src;
        image.alt = row.dataset.title.trim();
        image.width = 60;
        image.height = 60;
        image.loading = 'lazy';
        thumbnail.append(image);
      }
      const content = el('div',undefined,'cart-item__content');
      const inner = el('div');
      const price = items.reduce((sum,row)=>sum + Number(row.dataset.dtPackPrice || 0),0);
      const priceBlock = el('div',undefined,'cart-item__price');
      priceBlock.append(el('strong',money(price,first.dataset.dtPackCurrency)));
      const titleRow = el('div',undefined,'cart-item__title-row');
      const title = el('span',undefined,'cart-item__title');
      title.append(el('span',first.dataset.dtPackTitle));
      titleRow.append(title);
      const bundle = el('div',undefined,'cart-item__bundle bundle-components-container text-size--xsmall text-line-height--small');
      const details = el('details');
      const summary = el('summary',undefined,'cart-item__bundle-toggle');
      summary.append(el('span',first.dataset.dtPackShow.replace('__COUNT__',items.length),'show-bundle'),el('span',first.dataset.dtPackHide.replace('__COUNT__',items.length),'hide-bundle'));
      const icon = el('span',undefined,'cart-item__bundle-toggle-icon toggle-bundle-btn__icon');
      icon.setAttribute('aria-hidden','true');
      const nativeIcon = first.querySelector('.qty-plus svg');
      if (nativeIcon) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
        svg.setAttribute('width','13'); svg.setAttribute('height','8'); svg.setAttribute('viewBox','0 0 13 8');
        const path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d','M1 1L6.5 6.5L12 1'); path.setAttribute('fill','none'); path.setAttribute('stroke','currentColor'); path.setAttribute('stroke-width','1.5');
        svg.append(path); icon.append(svg);
      }
      summary.append(icon);
      const components = el('div',undefined,'cart-item__bundle-components');
      for (const row of items) {
        const component = el('div',undefined,'cart-item__bundle-component align-content align-content--vertical-middle');
        const sourceThumb = row.querySelector('.cart-item__thumbnail');
        if (sourceThumb) {
          const image = el('div',undefined,'cart-item__thumbnail element--border-width-clamped element--border-radius');
          for (const node of sourceThumb.childNodes) image.append(node.cloneNode(true));
          component.append(image);
        }
        const info = el('div',undefined,'cart-item__bundle-component-info');
        info.append(el('span','1 × ' + row.dataset.title.trim(),'text-weight--bold'));
        for (const property of row.querySelectorAll('.cart-item__property')) {
          if (property.querySelector('strong')?.textContent.trim() === 'Pack:') continue;
          info.append(property.cloneNode(true));
        }
        component.append(info); components.append(component);
      }
      details.append(summary,components); bundle.append(details);
      const actions = el('div',undefined,'cart-item__actions');
      const quantityHolder = el('div',undefined,'quantity-selector-holder dt-pilot-quantity');
      const minus = el('button',undefined,'qty-button qty-minus no-js-hidden');
      const plus = el('button',undefined,'qty-button qty-plus no-js-hidden');
      minus.type = plus.type = 'button';
      minus.setAttribute('aria-label',first.dataset.dtPackDecrease);
      plus.setAttribute('aria-label',first.dataset.dtPackIncrease);
      const minusSvg = first.querySelector('.qty-minus svg'), plusSvg = first.querySelector('.qty-plus svg');
      if(minusSvg) minus.append(minusSvg.cloneNode(true));
      if(plusSvg) plus.append(plusSvg.cloneNode(true));
      const input = el('input');
      input.type = 'number'; input.min = '1'; input.max = '99'; input.value = quantity;
      input.className = 'qty qty-selector product__quantity';
      input.setAttribute('aria-label',first.dataset.dtPackQuantity);
      const remove = el('button',first.dataset.dtPackRemove,'remove text-link text-size--xsmall text-color--opacity dt-pilot-remove');
      remove.type = 'button';
      const status = el('p'); status.setAttribute('role','alert');
      let updating = false;
      async function update(target) {
        if(updating) return;
        if(!Number.isInteger(target)||target<0||target>99){input.value=quantity;return;}
        updating=true; status.textContent='';
        [minus,plus,input,remove].forEach(control=>control.disabled=true);
        try {await changeGroupQuantity(id,target); await refreshDrawer(false);}
        catch(error) {
          status.textContent=first.dataset.dtPackError;
          input.value=quantity;
        } finally {updating=false;[minus,plus,input,remove].forEach(control=>control.disabled=false);}
      }
      minus.addEventListener('click',()=>update(quantity-1));
      plus.addEventListener('click',()=>update(quantity+1));
      input.addEventListener('change',()=>update(Number(input.value)));
      remove.addEventListener('click',()=>update(0));
      quantityHolder.append(minus,input,plus); actions.append(quantityHolder,remove);
      inner.append(priceBlock,titleRow,bundle,actions,status); content.append(inner);
      const sourceLines = el('div',undefined,'dt-pilot-source-lines'); sourceLines.hidden=true;
      first.before(wrapper);
      for(const row of items) sourceLines.append(row);
      wrapper.append(thumbnail,content,sourceLines);
    }
    const countElement = form.querySelector('[data-cart-count]');
    if (countElement) {
      let count = Number(countElement.textContent) || 0;
      const counted = new Set();
      for (const row of form.querySelectorAll('[data-dt-pack-group]')) {
        const group = row.dataset.dtPackGroup;
        if (!group) continue;
        const qty = Number(row.dataset.qty) || 0;
        count -= qty;
        if (!counted.has(group)) {count += qty; counted.add(group);}
      }
      for (const badge of document.querySelectorAll('[data-header-cart-count]')) {
        if (badge.textContent !== String(count)) badge.textContent = String(count);
      }
    }
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; renderGroups(); });
  }).observe(document.getElementById('AjaxCartForm') || document.body, {childList:true, subtree:true});
  renderGroups();
  const host = document.querySelector('[data-dt-pack-modal]');
  if (!host) return;
  const labels = JSON.parse(host.querySelector('[data-pilot-labels]').textContent);
  const dialog = host.querySelector('dialog');
  const choicesArea = host.querySelector('[data-pilot-choices]');
  const confirm = host.querySelector('[data-pilot-confirm]');
  const errorArea = host.querySelector('[data-pilot-dialog-error]');
  const launchError = host.querySelector('[data-pilot-launch-error]');
  const currency = host.dataset.currency;
  let catalogPromise, pack, selection, quantity = 1, trigger, busy = false, blocked = false, scrollLock, opening = false, openRevision = 0;
  const preparations = new Map();
  const introPrice = host.querySelector('[data-pilot-intro-price]');
  const rules = () => window.DTPackRules;
  const product = id => pack.products.find(item => item.id === id);
  const currencyMoney = cents => money(cents, currency);
  const catalog = () => catalogPromise ||= fetch(host.dataset.catalogUrl).then(response => {
    if (!response.ok) throw new Error(labels.error);
    return response.json();
  }).catch(error => {catalogPromise = null; throw error;});
  const baseSelection = () => pack.components.map(component => ({id:component.id, quantity:component.quantity}));
  const setBusy = value => {
    busy = value;
    if (trigger) {
      trigger.disabled = value || blocked;
      trigger.setAttribute('aria-busy', String(value));
      const controls = trigger.closest('[data-dt-pack-product]');
      controls?.querySelectorAll('.product-quantity button, [data-pilot-quantity]').forEach(control => {control.disabled = value;});
    }
    confirm.disabled = value || blocked;
    for (const field of choicesArea.querySelectorAll('fieldset')) field.disabled = value;
  };
  function lockPage() {
    if (scrollLock) return;
    const html = document.documentElement, body = document.body;
    const x = window.scrollX, y = window.scrollY;
    const gutter = Math.max(0, window.innerWidth - html.clientWidth);
    const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
    const saved = [];
    const set = (node, property, value) => {
      saved.push([node, property, node.style.getPropertyValue(property), node.style.getPropertyPriority(property)]);
      node.style.setProperty(property, value, 'important');
    };
    set(html, 'scroll-behavior', 'auto'); set(html, 'overflow', 'hidden'); set(html, 'overscroll-behavior', 'none');
    set(body, 'position', 'fixed'); set(body, 'top', -y + 'px'); set(body, 'left', -x + 'px');
    set(body, 'width', '100%'); set(body, 'overflow', 'hidden');
    if (gutter) set(body, 'padding-right', padding + gutter + 'px');
    scrollLock = {x, y, saved};
  }
  function unlockPage() {
    if (!scrollLock) return;
    const {x, y, saved} = scrollLock; scrollLock = null;
    for (const [node, property, value, priority] of [...saved].reverse()) {
      if (node === document.documentElement && property === 'scroll-behavior') continue;
      if (value) node.style.setProperty(property, value, priority); else node.style.removeProperty(property);
    }
    window.scrollTo({left:x, top:y, behavior:'instant'});
    const [node, property, value, priority] = saved[0];
    if (value) node.style.setProperty(property, value, priority); else node.style.removeProperty(property);
  }
  function closeDialog() {
    if (opening) {openRevision++; opening = false; setBusy(false);}
    dialog.close(); unlockPage();
  }
  dialog.addEventListener('close', () => {
    if (dialog.open) return;
    unlockPage();
    trigger?.focus({preventScroll:true});
  });
  dialog.addEventListener('cancel', event => {event.preventDefault(); if (!busy || opening) closeDialog();});
  host.querySelector('[data-pilot-cancel]').addEventListener('click', () => {if (!busy || opening) closeDialog();});
  const imageFor = (item, size) => {
    if (!item.image) return null;
    const image = el('img'); image.src = item.image; image.alt = ''; image.width = image.height = size;
    image.loading = 'lazy'; return image;
  };
  const availability = selected => {
    const item = selected && product(selected.id);
    return Boolean(item?.available && (item.stock == null || item.stock >= selected.quantity * quantity));
  };
  function sync() {
    const validation = pack.blocked ? 'blocked_gilda' : rules().validate(pack, selection);
    const unavailable = selection.some((item, index) => item && !pack.components[index].protector && !availability(item));
    const technicalMissing = pack.components.some((component, slot) => component.technical && !component.protector && !availability(selection[slot]));
    const issue = technicalMissing ? 'technical' : validation || (unavailable ? 'stock_changed' : null);
    host.querySelector('[data-pilot-modal-total]').replaceChildren(el('span', labels.total), el('strong', currencyMoney(rules().amount(pack, selection) * quantity)));
    const hint = host.querySelector('[data-pilot-modal-hint]');
    hint.textContent = labels[issue || 'ready_to_add']; hint.classList.toggle('is-ready', !issue);
    confirm.textContent = busy ? labels.busy : labels.add_personalized;
    confirm.disabled = busy || blocked || Boolean(issue);
    for (const field of choicesArea.querySelectorAll('fieldset[data-slot]')) {
      const slot = Number(field.dataset.slot);
      for (const radio of field.querySelectorAll('input')) {
        const otherSelection = radio.value !== 'omit' && selection.some((chosen, other) => other !== slot && chosen && (chosen.id === Number(radio.value) || product(chosen.id)?.sku && product(chosen.id).sku === product(Number(radio.value))?.sku));
        radio.disabled = busy || Boolean(otherSelection);
        radio.closest('label').hidden = Boolean(otherSelection) && !radio.checked;
        radio.closest('label').classList.toggle('is-selected', radio.checked);
      }
    }
  }
  function showChoices() {
    introPrice.hidden = false;
    dialog.removeAttribute('aria-busy');
    choicesArea.replaceChildren(); errorArea.textContent = '';
    host.querySelector('[data-pilot-pack-name]').textContent = pack.title;
    let count = 0;
    pack.components.forEach((component, slot) => {
      if (component.protector || component.technical) return;
      if (selection[slot] !== undefined && (!selection[slot] || availability(selection[slot]))) return;
      count++;
      const original = product(component.id);
      const field = el('fieldset', undefined, 'dt-choice-group'); field.dataset.slot = String(slot);
      field.append(el('legend', labels.unavailable, 'dt-choice-group__legend'));
      const originalCard = el('div', undefined, 'dt-choice-original');
      const image = imageFor(original, 64); if (image) originalCard.append(image);
      const details = el('div');
      details.append(el('h3', (component.quantity > 1 ? component.quantity + ' × ' : '') + original.title), el('p', currencyMoney(original.price * component.quantity)));
      originalCard.append(details); field.append(originalCard);
      field.append(el('p', labels.possible_substitutes, 'dt-choice-substitutes-title'));
      const candidates = [{id:component.id, quantity:component.quantity}, ...component.alternatives].filter(candidate => availability(candidate) && !pack.components.some((other, index) => index !== slot && other.id === candidate.id));
      if (!candidates.length && component.allowOmit) field.append(el('p', labels.no_replacements, 'dt-choice-empty'));
      if (!candidates.length && !component.allowOmit) field.append(el('p', labels.essential, 'dt-choice-empty'));
      for (const candidate of [...candidates, ...(component.allowOmit ? [null] : [])]) {
        const omission = !candidate, item = candidate && product(candidate.id);
        const delta = (item ? item.price * candidate.quantity : 0) - original.price * component.quantity;
        const card = el('label', undefined, 'dt-choice-option' + (omission ? ' dt-choice-option--omit' : ''));
        const radio = el('input'); radio.type = 'radio'; radio.name = 'dt-pack-slot-' + slot; radio.value = omission ? 'omit' : String(candidate.id); radio.required = true;
        radio.checked = selection[slot] === null ? omission : Boolean(selection[slot] && candidate && selection[slot].id === candidate.id);
        radio.addEventListener('change', () => {selection[slot] = candidate ? {...candidate} : null; errorArea.textContent = ''; sync();});
        card.append(radio);
        const image = item && imageFor(item, 72); if (image) card.append(image);
        const info = el('span', undefined, 'dt-choice-option__info');
        info.append(el('strong', omission ? labels.omit : (candidate.quantity > 1 ? candidate.quantity + ' × ' : '') + item.title));
        info.append(el('span', omission ? labels.omit_help : currencyMoney(item.price * candidate.quantity), 'dt-choice-option__detail'));
        info.append(el('span', (delta > 0 ? '+' : '') + currencyMoney(delta) + ' ' + labels.price_delta, 'dt-choice-option__delta'));
        card.append(info); field.append(card);
      }
      choicesArea.append(field);
    });
    host.querySelector('[data-pilot-intro-count]').textContent = labels[count === 1 ? 'intro_singular' : 'intro_plural'];
    host.querySelector('[data-pilot-intro-choose]').textContent = labels[count === 1 ? 'intro_choose_singular' : 'intro_choose_plural'];
    sync();
    if (!dialog.open) {lockPage(); try {dialog.showModal();} catch (error) {unlockPage(); throw error;}}
  }
  async function refreshProducts(target = pack) {
    const handles = [...new Set([target.handle, ...target.products.filter(item => item.public).map(item => item.handle)])];
    const result = new Map();
    let cursor = 0;
    const worker = async () => {
      while (cursor < handles.length) {
        const handle = handles[cursor++];
        const url = root + 'products/' + handle + (target.inventoryAware ? '?section_id=dt-pack-stock' : '.js');
        const response = await fetch(url, {cache:'no-store', headers:{Accept:target.inventoryAware ? 'text/html' : 'application/json'}});
        if (response.status === 404) {result.set(handle, null); continue;}
        if (!response.ok) throw new Error(labels.error);
        if (target.inventoryAware) {
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = html.querySelector('[data-dt-pack-live-product]');
          if (!data) throw new Error(labels.error);
          result.set(handle, JSON.parse(data.textContent));
        } else {
          result.set(handle, await response.json());
        }
      }
    };
    await Promise.all(Array.from({length:Math.min(6, handles.length)}, worker));
    const native = result.get(target.handle)?.variants?.find(item => item.id === target.variantId);
    if (!native) throw new Error(labels.error);
    target.price = native.price;
    for (const item of target.products) {
      const fresh = result.get(item.handle), variant = fresh?.variants?.find(variant => variant.id === item.id);
      // Native baskets use private, untracked packaging. Keep it as a required
      // component; the existing cart verification checks the actual expansion.
      item.available = Boolean(item.internalUntracked || item.public && variant?.available);
      if (target.inventoryAware) item.stock = variant?.stock ?? null;
      if (variant) item.price = variant.price;
    }
    return native;
  }
  function prepare(handle) {
    const cached = preparations.get(handle);
    if (cached && Date.now() - cached.created < 5000) return cached.promise;
    const entry = {created:Date.now()};
    entry.promise = catalog().then(async data => {
      if (!rules() || currency !== 'EUR' || !data.packs[handle]) throw new Error(labels.error);
      const target = structuredClone(data.packs[handle]);
      const native = await refreshProducts(target);
      return {pack:target, native};
    }).catch(error => {
      if (preparations.get(handle) === entry) preparations.delete(handle);
      throw error;
    });
    preparations.set(handle, entry);
    return entry.promise;
  }
  function showLoading(button) {
    choicesArea.replaceChildren(); errorArea.textContent = '';
    host.querySelector('[data-pilot-pack-name]').textContent = button.dataset.dtPackTitle;
    host.querySelector('[data-pilot-intro-count]').textContent = labels.loading;
    host.querySelector('[data-pilot-intro-choose]').textContent = '';
    introPrice.hidden = true;
    const loading = el('div', undefined, 'dt-choice-loading');
    loading.setAttribute('aria-hidden', 'true');
    choicesArea.append(loading);
    host.querySelector('[data-pilot-modal-total]').replaceChildren(el('span', labels.total), el('strong', currencyMoney(Number(button.dataset.dtPackPrice) * quantity)));
    const hint = host.querySelector('[data-pilot-modal-hint]');
    hint.textContent = labels.loading; hint.classList.remove('is-ready');
    confirm.textContent = labels.add_personalized; confirm.disabled = true;
    dialog.setAttribute('aria-busy', 'true');
    lockPage();
    try {dialog.showModal();} catch (error) {unlockPage(); throw error;}
  }
  async function addAndVerify(native = false) {
    const group = 'dt-pack-' + crypto.randomUUID();
    const entries = native ? [] : rules().items(pack, selection);
    const total = native ? pack.price : rules().amount(pack, selection);
    const properties = {__dt_pack_pilot_native:group};
    if (!native) {
      const changes = [];
      selection.forEach((chosen, slot) => {
        const component = pack.components[slot]; if (component.technical) return;
        if (!chosen) changes.push(labels.without + ' ' + product(component.id).title);
        else if (chosen.id !== component.id) changes.push(labels.with + ' ' + (chosen.quantity > 1 ? chosen.quantity + ' × ' : '') + product(chosen.id).title);
      });
      properties.__byob = JSON.stringify({v:2, s:{_BS_bundleId:group, _BS_productId:pack.mirror.productId}, c:entries.map(item => [String(item.id), item.quantity, item.price])});
      properties.__totalByob = properties.__totalByobPresentment = (total / 100).toFixed(2);
      properties.__totalByobPresentmentCurrency = currency;
      properties.__dt_pack_source = pack.handle;
      properties.__dt_pack_summary = changes.join(' · ');
    }
    const variantId = native ? pack.variantId : pack.mirror.variantId;
    let addError;
    try {await post('cart/add.js', {items:[{id:variantId, quantity, properties}]});} catch (error) {addError = error;}
    let cart;
    try {cart = await request('cart.js');} catch (error) {blocked = true; throw new Error(labels.partial_error);}
    const actual = groupItems(cart, group);
    let complete = actual.length === 1 && actual[0].variant_id === variantId && actual[0].quantity === quantity && actual[0].final_line_price === total * quantity;
    if (complete && !native) {
      try {
        const response = await fetch(root + '?section_id=helper-cart', {cache:'no-store'});
        if (!response.ok) throw new Error(labels.error);
        const rendered = new DOMParser().parseFromString(await response.text(), 'text/html');
        const row = [...rendered.querySelectorAll('[data-js-cart-item]')].find(item => item.dataset.id === actual[0].key);
        const components = [...(row?.querySelectorAll('[data-dt-component-variant]') || [])];
        complete = row?.dataset.dtIsBundle === 'true' && components.length === entries.length && entries.every(expected => components.some(component => Number(component.dataset.dtComponentVariant) === expected.id && Number(component.dataset.dtComponentQuantity) === expected.quantity * quantity));
      } catch (error) {complete = false;}
    }
    if (!complete) {
      try {await removeGroup(group);} catch (error) {blocked = true; throw new Error(labels.partial_error);}
      throw new Error(addError?.message || labels.error);
    }
    if (dialog.open) closeDialog();
    try {await refreshDrawer(true);} catch (error) {launchError.textContent = labels.refresh_error;}
  }
  async function start(button) {
    if (busy || blocked || dialog.open) return;
    trigger = button; launchError.textContent = '';
    const quantityInput = button.closest('[data-dt-pack-product]')?.querySelector('[data-pilot-quantity]');
    quantity = Number(quantityInput?.value || 1);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) {quantityInput?.reportValidity(); return;}
    const revision = ++openRevision;
    opening = true;
    button.classList.add('is-dt-pack-pressed');
    setTimeout(() => button.classList.remove('is-dt-pack-pressed'), 160);
    setBusy(true);
    try {
      showLoading(button);
      const prepared = await prepare(button.dataset.dtPackOpen);
      if (revision !== openRevision) return;
      pack = prepared.pack;
      const native = prepared.native;
      selection = baseSelection();
      opening = false;
      if (native.available && (!pack.inventoryAware || selection.every(availability))) {await addAndVerify(true); return;}
      selection = selection.map((item, slot) => !pack.components[slot].technical && !availability(item) ? undefined : item);
      showChoices();
    } catch (error) {
      if (revision !== openRevision) return;
      opening = false;
      dialog.removeAttribute('aria-busy');
      choicesArea.replaceChildren();
      host.querySelector('[data-pilot-modal-hint]').textContent = '';
      errorArea.textContent = error.message || labels.error;
      confirm.disabled = true;
    } finally {
      if (revision === openRevision) {setBusy(false); if (dialog.open && !errorArea.textContent) sync(); else confirm.disabled = true;}
    }
  }
  async function finish() {
    if (busy || blocked || rules().validate(pack, selection)) return;
    const oldTotal = rules().amount(pack, selection);
    setBusy(true); sync(); errorArea.textContent = '';
    try {
      await refreshProducts();
      let changed = false;
      selection = selection.map((item, slot) => {
        if (item && !pack.components[slot].technical && !availability(item)) {changed = true; return undefined;}
        return item;
      });
      if (changed) {showChoices(); errorArea.textContent = labels.stock_changed; return;}
      if (pack.components.some((component, slot) => component.technical && !component.protector && !availability(selection[slot]))) throw new Error(labels.technical);
      const entries = rules().items(pack, selection);
      if (entries.some(item => !availability(item))) throw new Error(labels.technical);
      if (rules().amount(pack, selection) !== oldTotal) {sync(); errorArea.textContent = labels.price_changed; return;}
      await addAndVerify();
    } catch (error) {errorArea.textContent = error.message || labels.error;}
    finally {setBusy(false); if (dialog.open) sync();}
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-dt-pack-open]'); if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation(); start(button);
  }, true);
  const warm = event => {
    const button = event.target.closest?.('[data-dt-pack-open]');
    if (button && !busy && !blocked) prepare(button.dataset.dtPackOpen).catch(() => {});
  };
  document.addEventListener('pointerover', warm, {passive:true});
  document.addEventListener('focusin', warm);
  document.addEventListener('pointerdown', warm, {passive:true});
  if (document.querySelector('[data-dt-pack-open]')) {
    if ('requestIdleCallback' in window) requestIdleCallback(() => catalog().catch(() => {}), {timeout:1000});
    else setTimeout(() => catalog().catch(() => {}), 0);
  }
  confirm.addEventListener('click', finish);
})();


